import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { PatientFilterType, PatientInfoType, PatientType } from '@/shared/types'
import { PatientDataMapper } from '@/shared/mappers'

class PatientApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getPatientListing(filters: PatientFilterType) {
    const { dateFrom, dateTo, search } = filters

    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/patients',
      params: {
        date_from: dateFrom,
        date_to: dateTo,
        search,
      },
    })
  }

  public getPatientInfo(patientId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/patients/patient/get',
      params: {
        patient_id: patientId,
      },
    })
  }

  public getPatientCfe(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/kjfkds',
      data: {
        reportId: reportId,
      },
    })
  }

  public createPatient(patientInfo: PatientInfoType) {
    const data = PatientDataMapper.mapPatientCreationData(patientInfo)

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/patients/patient/create',
      data,
    })
  }

  public editPatient(patientInfo: PatientType) {
    const data = PatientDataMapper.mapPatientEditionData(patientInfo)

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/patients/patient/update',
      data,
    })
  }

  public removePatient(patientId: number) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/patients/patient/delete',
      params: {
        patient_id: patientId,
      },
    })
  }
}

export const patientApi = new PatientApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
